export default "__VITE_PUBLIC_ASSET__439253f9__"